export function getContainer(container, defaultContainer) {
  if (!container) return defaultContainer;
  if (container && 'current' in container) {
    return container.current;
  }
  if (container instanceof HTMLElement) {
    return container;
  }
  if (typeof container === 'function') {
    return getContainer(container(), defaultContainer);
  }
  return defaultContainer;
}
//# sourceMappingURL=getContainer.js.map